import Vue from 'vue'
import {
  Button,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  Search,
  Swipe,
  SwipeItem,
  Lazyload,
  DropdownMenu,
  DropdownItem,
  Tag,
  Image as VanImage,
  Form,
  NavBar,
  IndexBar,
  IndexAnchor,
  GoodsAction,
  GoodsActionButton,
  GoodsActionIcon,
  Toast,
  Dialog,
  Collapse,
  CollapseItem,
  ImagePreview,
  Icon,
  Tabbar,
  TabbarItem,
  Tab,
  Tabs,
  Grid,
  GridItem,
  Popup,
  Sticky,
  Field,
  Picker,
  Overlay,
  Switch,
  DatetimePicker,
  Uploader
} from 'vant'

Vue.use(Button)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Search)
Vue.use(Swipe)
Vue.use(Lazyload)
Vue.use(SwipeItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tag)
Vue.use(VanImage)
Vue.use(Form)
Vue.use(NavBar)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(GoodsAction)
Vue.use(GoodsActionButton)
Vue.use(GoodsActionIcon)
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$imagePreview = ImagePreview
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Icon)

// 商铺加上
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Popup)
Vue.use(Sticky)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Overlay)

Vue.use(Switch)
Vue.use(DatetimePicker)
Vue.use(Uploader)
